import React from "react";

const ProfileSkeleton = () => {
  return (
    <div className="w-full overflow-hidden shadow-md p-6 rounded-xl">
      {/* Orange header */}
      <div className="w-full h-32 bg-orange-500 relative rounded-xl">
        {/* Edit profile button */}
        <div className="absolute top-4 right-4">
          <div className="bg-blue-500 text-white rounded px-4 py-2 flex items-center space-x-2">
            <div className="w-4 h-4 bg-white/30 rounded-full animate-pulse"></div>
            <div className="w-20 h-4 bg-white/30 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Profile image placeholder */}
        <div className="absolute -bottom-14 left-8">
          <div className="w-28 h-28 rounded-full border-4 border-white bg-gray-200 animate-pulse"></div>
        </div>
      </div>

      {/* Profile content */}
      <div className="bg-white pt-16 pb-6 px-8">
        {/* Name */}
        <div className="w-56 h-7 bg-gray-200 rounded animate-pulse mb-2"></div>
        {/* Member since */}
        <div className="w-40 h-5 bg-gray-200 rounded animate-pulse mb-8"></div>

        {/* Contact Information */}
        <div className="mb-6">
          <div className="w-40 h-6 bg-gray-200 rounded animate-pulse mb-4"></div>

          {/* Email section */}
          <div className="mb-4">
            <div className="w-20 h-5 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="w-48 h-5 bg-gray-200 rounded animate-pulse"></div>
          </div>

          {/* Phone section */}
          <div>
            <div className="w-20 h-5 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="w-32 h-5 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>

        {/* Personal Information */}
        <div>
          <div className="w-40 h-6 bg-gray-200 rounded animate-pulse mb-4"></div>

          {/* Gender section */}
          <div>
            <div className="w-20 h-5 bg-gray-200 rounded animate-pulse mb-2"></div>
            <div className="w-24 h-5 bg-gray-200 rounded animate-pulse"></div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ProfileSkeleton;
